/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').
    factory('BookingService_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        var  resourceBookingS = $resource(baseUrl + 'rest/bookingServices/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET' }
        });
        return resourceBookingS;
    }
    ]);

angular.module('FlexyBeautyApp.services').
factory('BookingService',["BookingService_Resource","HumanResourceData","PhysicalResourceData","CategoryData","Activity","ServiceData", "GiftItemData","ActivityData","TaxMode","VatData","HumanResource","PhysicalResource",
    "Category","Service","RootStatCategorie","HrRootOccupationRateCategory","PrRootOccupationRateCategory","NbCustormerCategoryStat","TypeOfCustomerRootCategory","TypeOfCustomer","HrRootCategory","TypeOfBooking","BookingCreator",
        function (BookingService_Resource,HumanResourceData,PhysicalResourceData,CategoryData,Activity,ServiceData,GiftItemData,ActivityData,TaxMode,VatData,HumanResource,PhysicalResource,
                  Category,Service,RootStatCategorie,HrRootOccupationRateCategory,PrRootOccupationRateCategory,NbCustormerCategoryStat,TypeOfCustomerRootCategory,TypeOfCustomer,HrRootCategory,TypeOfBooking,BookingCreator)
    {
    //BookingService inherit from Activity
    var  BookingService = function (bookingServiceRes,isPreviousVersion, isApplicationLoading)
    {
        this.price = 0;
        this.originalPrice = 0;
        this.discountPercent = 0;
        this.idInBooking = null;
        this.hrRequest=false;
        this.isPackage = false;
        this.billPosition=0;
        this.service=null;
        this.subBookingServices=[];
        this.booking = null;
        this.cureItemToServiceUsage=null;
        this.giftItem=null;
        this.secondariesDayPrs = [];
        this.secondariesDayHrs = [];
        this._secondariesDayPrsId = []; //tmp for loading
        this._secondariesDayHrsId = []; //tmp for loading
        this.pkg = null;//package
        Activity.call(this,bookingServiceRes,isPreviousVersion, isApplicationLoading); //call super() -> call BookingService.prototype.loadObject ->  call Activity.prototype.loadObject

    };

    BookingService.prototype = Object.create(Activity.prototype);//get all functions of super()

    BookingService.prototype.loadObject = function(object,isPreviousVersion, isApplicationLoading)
    {

        //Call super function
        Activity.prototype.loadObject.call(this,object);

        if (object!==undefined && object!=null)
        {
            this.price = object.price;
            if (object.originalPrice!==undefined && object.originalPrice)
                this.originalPrice=object.originalPrice;
            else
                this.originalPrice=object.price;
            this.discountPercent=object.discountPercent;
            this.hrRequest=object.hrRequest;
            this.isPackage = object.isPackage;
            this._serviceId=object.serviceId;
            this._giftItemId=object.giftItemId;
            if(object.idInBooking != null)
                this.idInBooking = object.idInBooking;

            if (object.subBookingServices) {
                this.subBookingServices = [];//set to 0 and reload
                for (var i = 0; i < object.subBookingServices.length; i++)
                {
                    var subBs = ActivityData.getById(object.subBookingServices[i].id, isApplicationLoading);//can happens on propagation
                    if (subBs && (isPreviousVersion==undefined || !isPreviousVersion))
                    {
                        subBs.loadObject(object.subBookingServices[i], null, isApplicationLoading);
                        subBs.pkg=this;
                        subBs.booking = this.booking;
                    }
                    else
                    {
                        subBs = new BookingService(object.subBookingServices[i], isPreviousVersion, isApplicationLoading);
                        subBs.booking = this.booking;
                        subBs.pkg=this;
                    }
                    this.addSubBs(subBs);

                }
            }
            //no need to load  secondariesDayPrsId (will be done from dayHR or DayPr)
            // cureItemToServiceUsage is loaded by cureItemToServiceUsage
        }
    };
    BookingService.prototype.loadRef = function()
    {
        if (this._serviceId)
            this.service = ServiceData.getById(this._serviceId);

        if (this._giftItemId)
            this.giftItem = GiftItemData.getById(this._giftItemId);

        for (var i=0; i< this.subBookingServices.length;i++)
            this.subBookingServices[i].loadRef();

    };
    BookingService.prototype.getSubBookingServiceById = function(id)
    {
        for (var i=0; i< this.subBookingServices.length;i++)
            if (this.subBookingServices[i].id==id)
                return this.subBookingServices[i];
        return null;
    };
    BookingService.prototype.copyDataTo = function(object)
    {


        //Call super function
        Activity.prototype.copyDataTo.call(this,object);

        //copy specifics fields
        object.price=this.price;
        object.idInBooking = this.idInBooking;
        object.originalPrice=this.originalPrice;
        object.discountPercent=this.discountPercent;
        object.hrRequest=this.hrRequest;
        object.isPackage=this.isPackage;

        if (this.service)
            object.serviceId = this.service.getId();
        else
            object.serviceId = null;

        if (this.booking)
            object.bookingId = this.booking.getId();
        else
            object.bookingId = null;

        object.secondariesDayHrs=[];
        object.secondariesDayHrsId=[];
        for (var i=0;i< this.secondariesDayHrs.length;i++){
            if (this.secondariesDayHrs[i].id)
                object.secondariesDayHrsId.push(this.secondariesDayHrs[i].id);
            else
                object.secondariesDayHrs.push(this.secondariesDayHrs[i].getObjectResourceCreatedByActivity());
        }
        object.secondariesDayPrs=[];
        object.secondariesDayPrsId=[];
        for (var i=0;i< this.secondariesDayPrs.length;i++){
            if (this.secondariesDayPrs[i].id)
                object.secondariesDayPrsId.push(this.secondariesDayPrs[i].id);
            else
                object.secondariesDayPrs.push(this.secondariesDayPrs[i].getObjectResourceCreatedByActivity());
        }

        if (this.cureItemToServiceUsage)
            object.cureItemToServiceUsage = this.cureItemToServiceUsage.getObjectResource();

        if (this.giftItem)
            object.giftItemId = this.giftItem.id;
        else
            object.giftItemId = null;

        object.subBookingServices=[];
        for (var i=0;i< this.subBookingServices.length;i++){
            object.subBookingServices.push(this.subBookingServices[i].getObjectResource());
        }

    };
    // Override  from Activity.getObjectResource
    BookingService.prototype.getObjectResource = function()
    {
        var bookingServiceRes = new BookingService_Resource();
        this.copyDataTo(bookingServiceRes);
        return bookingServiceRes;
    };
    BookingService.prototype.setIdUsingObject = function(object)
    {
        this.id = object.id;
        if (this.subBookingServices!=null && object.subBookingServices!=null)
            for (var i=0;i< this.subBookingServices.length;i++)
                this.subBookingServices[i].setIdUsingObject(object.subBookingServices[i]);
    };
    BookingService.prototype.setId = function(id)
    {
        if (this.id==null)
            this.id = id;
    };
    BookingService.prototype.setService = function(service)
    {
        this.service = service;
    };
    BookingService.prototype.getService = function()
    {
        return this.service;
    };
    BookingService.prototype.getId = function()
    {
        return this.id;
    };
    BookingService.prototype.getLabel = function()
    {
        return this.label;
    };
    BookingService.prototype.getPrice = function()
    {
        return this.price;
    };
    BookingService.prototype.getIsPackage = function()
    {
        return this.isPackage;
    };
    BookingService.prototype.addSecondaryDayHr = function(dayHr)
    {
        var index = this.secondariesDayHrs.indexOf(dayHr);
        if (index==-1)
            this.secondariesDayHrs.push(dayHr) ;
    };
    BookingService.prototype.removeSecondaryDayHr = function(dayHr)
    {
        var index = this.secondariesDayHrs.indexOf(dayHr);
        if (index!=-1)
            this.secondariesDayHrs.splice(index,1) ;
    };
    BookingService.prototype.addSecondaryDayPr = function(dayPr)
    {
        var index = this.secondariesDayPrs.indexOf(dayPr);
        if (index==-1)
            this.secondariesDayPrs.push(dayPr) ;
    };
    BookingService.prototype.removeSecondaryDayPr = function(dayPr)
    {
        var index = this.secondariesDayPrs.indexOf(dayPr);
        if (index!=-1)
            this.secondariesDayPrs.splice(index,1) ;
    };
    BookingService.prototype.addSubBs = function(bs)
    {
        if ( bs) {
            var index = this.subBookingServices.indexOf(bs);
            if (index == -1) {
                this.subBookingServices.push(bs);
                bs.pkg = this;
            }
        }
    };
    BookingService.prototype.getHumanResource = function()
    {
        var humanResource = null;
        if(this.dayHr && this.dayHr.humanResourceId){
            humanResource = HumanResourceData.getById(this.dayHr.humanResourceId);
        }
        return humanResource;
    };
    BookingService.prototype.getPhysicalResource = function()
    {
        var physicalResource = null;
        if(this.dayPr && this.dayPr.physicalResourceId){
            physicalResource = PhysicalResourceData.getById(this.dayPr.physicalResourceId);
        }
        return physicalResource;
    };
    BookingService.prototype.getDiscountPrice = function(taxMode)
    {
        var price = 0;

        if (this.getBooking() && ((this.getBooking().sale && this.getBooking().sale.isStatusSoldOrCreditOrCanceled()) || (!this.getBooking().sale))) {
            if(this.subBookingServices.length > 0){
                for(var i = 0; i < this.subBookingServices.length; i++){
                    price += this.subBookingServices[i].price;
                }
            }
            else{
                price = this.price;
            }

            if(taxMode === TaxMode.HT){
                var defaultVat = VatData.getDefaultVat();
                price = price / (100 + defaultVat.tax) * 100;
            }
        }
        else{//there is a sale attach to the booking
            price = this.getCorrespondingSaleService().getDiscountPrice(taxMode);
        }

        return price;
    };

    BookingService.prototype.getCorrespondingSaleService = function()
    {
        var correspondingSaleService = null;
        if(this.getBooking() && this.getBooking().sale){
            for(var i = 0; i < this.getBooking().bookingServices.length;i++){
                if(!this.pkg) {
                    if (this.booking.bookingServices[i] === this && this.booking.sale.saleServices[i]) {
                        correspondingSaleService = this.booking.sale.saleServices[i];
                    }
                }
                else{
                    for(var j = 0; j < this.getBooking().bookingServices[i].subBookingServices.length;j++){
                        if(this.getBooking().bookingServices[i].subBookingServices[j] === this && this.getBooking().sale.saleServices[i].subSaleServices[j]){
                            correspondingSaleService = this.getBooking().sale.saleServices[i].subSaleServices[j];
                        }
                    }
                }
            }
        }
        return correspondingSaleService;
    };

    BookingService.prototype.getBooking = function()
    {
        var booking = this.booking;
        if(this.pkg){
            booking = this.pkg.booking;
        }
        return booking;
    };

    BookingService.prototype.matchAllBookingObjects = function(bookingObjects, additionalFilters, firstDayOfPeriod){
        let matchAllBookingObject = true,
            service = this.getService();

        for (let k = 0; k < bookingObjects.length; k++) {
            let bookingObject = bookingObjects[k],
                matchBookingObject = false;

            if ((bookingObject instanceof HumanResource && this.dayHr && this.dayHr.humanResourceId === bookingObject.id) ||
                (bookingObject instanceof PhysicalResource && this.dayPr && this.dayPr.physicalResourceId === bookingObject.id) ||
                (bookingObject instanceof Category && service && service.isDescendantOf(bookingObject)) ||
                (bookingObject instanceof Service && service && (service === bookingObject || (bookingObject.isPackage && bookingObject.subServices.indexOf(service) !== -1))) ||
                (bookingObject === RootStatCategorie) ||
                (bookingObject === HrRootCategory) ||
                (bookingObject === HrRootOccupationRateCategory) ||
                (bookingObject === PrRootOccupationRateCategory) ||
                (bookingObject === NbCustormerCategoryStat) ||
                (bookingObject === NbCustormerCategoryStat.subCategories.MEN_VISITS &&  this.getBooking().customer && this.getBooking().customer.gender === 'M') ||
                (bookingObject === NbCustormerCategoryStat.subCategories.WOMEN_VISITS && this.getBooking().customer && this.getBooking().customer.gender === 'W') ||
                (bookingObject === NbCustormerCategoryStat.subCategories.CHILDREN_VISITS && this.getBooking().customer && this.getBooking().customer.gender === 'C') ||
                (bookingObject === NbCustormerCategoryStat.subCategories.UNDEFINED_VISITS && this.getBooking().customer && this.getBooking().customer.gender === null) ||
                (bookingObject === NbCustormerCategoryStat.subCategories.PASSENGER_VISITS && !this.getBooking().customer) ||
                (bookingObject === TypeOfCustomerRootCategory) ||
                (bookingObject === TypeOfCustomer.OLD_CUSTOMER && this.getBooking().customer && (this.getBooking().customer.hasSaleBefore(firstDayOfPeriod, this.getBooking()) || this.getBooking().customer.hasBookingBefore(firstDayOfPeriod))) ||
                (bookingObject === TypeOfCustomer.NEW_CUSTOMER && (!this.getBooking().customer || (!this.getBooking().customer.hasSaleBefore(firstDayOfPeriod, this.getBooking()) && !this.getBooking().customer.hasBookingBefore(firstDayOfPeriod)))) ||
                (bookingObject === TypeOfBooking.COME_AND_NOT_COME) ||
                (bookingObject === TypeOfBooking.COME && this.getBooking().status !== 'notCame') ||
                (bookingObject === TypeOfBooking.NOT_COME && this.getBooking().status === 'notCame') ||
                (bookingObject === TypeOfBooking.CREATE_BY_CUSTORMER_AND_NOT) ||
                (bookingObject === TypeOfBooking.CREATE_BY_CUSTORMER && this.getBooking().isCreatedByCustomer) ||
                (bookingObject === TypeOfBooking.NOT_CREATE_BY_CUSTOMER && !this.getBooking().isCreatedByCustomer) ||
                (bookingObject === TypeOfBooking.CREATE_BY_RWG && this.getBooking().checkBookingCreator(BookingCreator.RWG.key)) ||
                (bookingObject === TypeOfBooking.CREATE_BY_WEBSITE && this.getBooking().isCreatedByCustomer && !this.getBooking().checkBookingCreator(BookingCreator.RWG.key))
            ) {
                matchBookingObject = true;
            }
            matchAllBookingObject = matchAllBookingObject && matchBookingObject;
        }

        let matchOneAdditionalFilter = false;

        for (let k = 0; k < additionalFilters.length; k++) {
            let additionalFilter = additionalFilters[k],
                matchAdditionalFilter = false;

            if (
                (additionalFilter === NbCustormerCategoryStat.subCategories.MEN_VISITS && this.getBooking().customer && this.getBooking().customer.gender === 'M') ||
                (additionalFilter === NbCustormerCategoryStat.subCategories.WOMEN_VISITS && this.getBooking().customer && this.getBooking().customer.gender === 'W') ||
                (additionalFilter === NbCustormerCategoryStat.subCategories.CHILDREN_VISITS && this.getBooking().customer && this.getBooking().customer.gender === 'C') ||
                (additionalFilter instanceof HumanResource && this.humanResource === additionalFilter)
            ) {

                matchAdditionalFilter = true;

            }
            matchOneAdditionalFilter = matchOneAdditionalFilter || matchAdditionalFilter;
        }

        return (matchAllBookingObject && (matchOneAdditionalFilter || additionalFilters.length === 0));
    };

    BookingService.prototype.incrementBookingDatas = function(bookingDatas, bookingObjects, additionalFilters, firstDayOfPeriod, taxMode, currentDay){
        if(this.matchAllBookingObjects(bookingObjects, additionalFilters, firstDayOfPeriod)) {

            for (let k = 0; k < bookingObjects.length; k++) {
                let bookingObject = bookingObjects[k];

                if (bookingObject instanceof HumanResource) {
                    bookingDatas.humanResource = bookingObject;
                    break;
                }
            }
            if(this.getBooking() != null){
                if (bookingDatas.bookings.indexOf(this.getBooking()) === -1) {
                    bookingDatas.bookings.push(this.getBooking());

                    let priceTTC = this.getBooking().price - (this.getBooking().price / 100 * this.getBooking().discountPercent);

                    if (taxMode === TaxMode.HT) {
                        bookingDatas.price += priceTTC / (100 + VatData.getDefaultVat().tax) * 100;
                    }
                    else {
                        bookingDatas.price += priceTTC;
                    }
                }

                if (this.getBooking().status !== 'notCame') {
                    if (this.pkg && bookingDatas.subBookings.indexOf(this.pkg) === -1) {
                        bookingDatas.subBookings.push(this.pkg);
                    }
                    else if (!this.pkg) {
                        bookingDatas.subBookings.push(this);
                    }

                    bookingDatas.subBookingsStep.push(this);
                }

                if (firstDayOfPeriod) {
                    if (this.getBooking().status !== 'notCame' && this.getBooking().customer) {
                        let salesOfPeriod = this.getBooking().customer.getLoyaltySalesOfPeriod(firstDayOfPeriod, currentDay, bookingDatas.humanResource ? bookingDatas.humanResource.id : null, this.getBooking()),
                            bookingsOfPeriod = this.getBooking().customer.getLoyaltyBookingsOfPeriod(firstDayOfPeriod, currentDay, bookingDatas.humanResource ? bookingDatas.humanResource.id : null);

                        if (salesOfPeriod.length > 0 || bookingsOfPeriod.length > 0) {
                            if (bookingDatas.loyaltyCustormers.indexOf(this.getBooking().customer) === -1) {
                                bookingDatas.loyaltyCustormers.push(this.getBooking().customer);
                            }
                        }
                        else {
                            bookingDatas.customersFirstVisit.push(this.getBooking().customer);
                        }
                    }
                }

                if (this.getBooking().status !== 'notCame' && this.getBooking().customer) {
                    if (bookingDatas.customers.indexOf(this.getBooking().customer) == -1) {
                        bookingDatas.customers.push(this.getBooking().customer);
                    }

                    if (this.getBooking().status !== 'notCame' && (!this.getBooking().sale || (this.getBooking().sale && this.getBooking().sale.status !== 'canceled' && this.getBooking().sale.status !== 'credit' && this.getBooking().sale.day && this.getBooking().day && firstDayOfPeriod && (this.getBooking().sale.day.id >= this.getBooking().day.id || this.getBooking().sale.day.id < firstDayOfPeriod.id)))) {
                        if (bookingDatas.customersBookings.indexOf(this.getBooking().customer) == -1) {
                            bookingDatas.customersBookings.push(this.getBooking().customer);
                            if (!this.getBooking().customer.hasSaleBetween(firstDayOfPeriod, currentDay, this.getBooking()) && !this.getBooking().customer.hasBookingBetween(firstDayOfPeriod, currentDay)) {
                                bookingDatas.customersFirstBookings.push(this.getBooking().customer);
                            }

                            if (!this.getBooking().customer.hasSaleBetween(firstDayOfPeriod, currentDay, this.getBooking(), bookingObjects, additionalFilters, currentDay) && !this.getBooking().customer.hasBookingBetween(firstDayOfPeriod, currentDay, null, bookingObjects, additionalFilters, currentDay)) {
                                bookingDatas.customersFirstBookingsOfBookingObject.push(this.getBooking().customer);
                            }
                        }
                    }
                }
                else {
                    if (this.getBooking().status !== 'notCame' && bookingDatas.matchedBookingsOfPassageCustomer.indexOf(this.getBooking()) === -1) {
                        bookingDatas.matchedBookingsOfPassageCustomer.push(this.getBooking());
                    }
                }
            }
        }
    };


    return BookingService;
    }
]);

angular.module('FlexyBeautyApp.services').factory('BookingServiceSrv',[
        "$log", "ServerSrv", "DayData", "ActivityData", "BookingService", "WorkingPeriodDayHrData",
        "WorkingPeriodDayPrData", "DayHrData", "DayPrData", "ActivitySrv", "BookingData",
    function($log, ServerSrv, DayData, ActivityData, BookingService, WorkingPeriodDayHrData, WorkingPeriodDayPrData,
             DayHrData, DayPrData, ActivitySrv, BookingData) {
        var  bsSrv = {};

        bsSrv.save =  function(bookingService,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(bsSrv.saveSync, bookingService, successFunction, errorFunction);
        };
        bsSrv.saveSync =  function(bookingService,successFunction,errorFunction)
        {
            //$timeout (function () {

            var bsRes = bookingService.getObjectResource();
            bsRes.$save({}, //no params
                function (data) {
                    //Save on server success :
                    // -> set id for new entity and subones
                    // -> add an user action (send message)

                    try {
                        // now we can set the id
                        bookingService.setId(data.id);

                        //Add user action
                        //UserActionSrv.add(data.userAction);
                        //CallBack on success
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null),"BookingService.saveSync - Error on save and server call queue not empty");
                    }
                }
            );

            //},2000)
        };

        bsSrv.updateLocallyOnDay = function(resource, bookingService) {
            if (bookingService.secondariesDayHrs) {
                for (let k = 0; k < bookingService.secondariesDayHrs.length; k++) {
                    bookingService.secondariesDayHrs[k].removeActivity(bookingService);
                }
                bookingService.secondariesDayHrs=[];
            }
            if (bookingService.secondariesDayPrs) {
                for (let k = 0; k < bookingService.secondariesDayPrs.length; k++) {
                    bookingService.secondariesDayPrs[k].removeActivity(bookingService);
                }
                bookingService.secondariesDayPrs = [];
            }
            ActivitySrv.updateLocally(resource.id, resource);
            if (resource.secondariesDayHrsId) {
                for (let k = 0; k < resource.secondariesDayHrsId.length; k++) {
                    let secondaryDayHr = DayHrData.getById(resource.secondariesDayHrsId[k]);
                    if (secondaryDayHr) {
                        secondaryDayHr.addActivity(bookingService, false);
                    } else {
                        console.log("BookingService.updateLocallyOnDay - SecondaryDayHr not found given ID - SecondaryDayHr ID: " + resource.secondariesDayHrsId);
                    }
                }
            }
            if (resource.secondariesDayPrsId) {
                for (let k = 0; k < resource.secondariesDayPrsId.length; k++) {
                    let secondaryDayPr = DayPrData.getById(resource.secondariesDayPrsId[k]);
                    if (secondaryDayPr) {
                        secondaryDayPr.addActivity(bookingService, false);
                    } else {
                        console.log("BookingService.updateLocallyOnDay - SecondaryDayPr not found given ID - SecondaryDayPr ID: " + resource.secondariesDayPrsId);
                    }
                }
            }
        };

        bsSrv.updateLocally = function(id, resource) {
            if (!resource.pkgId) { // subBs managed by pkg
                //not specific code to manage update/remove from booking because this link is change only for a add or delete
                // (a bookingService can't be moved to another booking)
                let bookingService = ActivityData.getById(id);
                if (bookingService != null) {
                    if (bookingService.version && resource.version && resource.version <= bookingService.version) {
                        return null;
                    }
                    bsSrv.updateLocallyOnDay(resource, bookingService);
                    for (let i = 0; i < resource.subBookingServices.length; i++) {
                        bsSrv.updateLocallyOnDay(resource.subBookingServices[i], bookingService.subBookingServices[i]); // subBs on Days
                    }
                } else {
                    console.log("BookingService.updateLocally - Model not found given ID - BookingService ID: " + id);
                }
                return bookingService;
            } else {
                return null;
            }
        };

        bsSrv.removeLocally = function(id, resource) {
            if (!resource.pkgId) { // subBs managed by pkg
                let bookingService = ActivityData.getById(id);
                if (bookingService != null) {
                    if (bookingService.version && resource.version && resource.version <= bookingService.version) {
                        return null;
                    }

                    if (bookingService.workingPeriodDayHr) {
                        bookingService.workingPeriodDayHr.removeActivity(bookingService);
                    }
                    if (bookingService.dayHr) {
                        bookingService.dayHr.removeActivity(bookingService);
                    }
                    if (bookingService.workingPeriodDayPr) {
                        bookingService.workingPeriodDayPr.removeActivity(bookingService);
                    }
                    if (bookingService.dayPr) {
                        bookingService.dayPr.removeActivity(bookingService);
                    }

                    for (let k = 0; k < bookingService.secondariesDayHrs.length; k++) {
                        bookingService.secondariesDayHrs[k].removeActivity(bookingService);
                    }
                    for (let k = 0; k < bookingService.secondariesDayPrs.length; k++) {
                        bookingService.secondariesDayPrs[k].removeActivity(bookingService);
                    }
                    //remove from booking
                    if (bookingService.booking) {
                        bookingService.booking.removeBookingService(bookingService);
                    } else {
                        console.log("BookingService.removeLocally - bookingService.booking is null - BookingService ID: " + id);
                    }
                } else {
                    console.log("BookingService.removeLocally - Model not found given ID - BookingService ID: " + id);
                }
                return bookingService;
            }
            else {
                return null;
            }
        };

        bsSrv.addLocallyOnDay = function(resource, bookingService) {
            if (resource.dayHrId) {
                let dayHr = DayHrData.getById(resource.dayHrId);
                if (dayHr) {
                    dayHr.addActivity(bookingService, true);
                } else {
                    console.log("BookingService.addLocallyOnDay - DayHr not found given ID - DayHr ID: " + resource.dayHrId);
                }
            } else if (resource.workingPeriodDayHrId) {
                let workingPeriodDayHr = WorkingPeriodDayHrData.getById(resource.workingPeriodDayHrId);
                if (workingPeriodDayHr) {
                    workingPeriodDayHr.addActivity(bookingService);
                } else {
                    console.log("BookingService.addLocallyOnDay - WorkingPeriodDayHr not found given ID - WorkingPeriodDayHr ID: " + resource.workingPeriodDayHrId);
                }
            }
            if (resource.dayPrId) {
                let dayPr = DayPrData.getById(resource.dayPrId);
                if (dayPr) {
                    dayPr.addActivity(bookingService, true);
                } else {
                    console.log("BookingService.addLocallyOnDay - DayPr not found given ID - DayPr ID: " + resource.dayPrId);
                }
            } else if (resource.workingPeriodDayPrId) {
                let workingPeriodDayPr = WorkingPeriodDayPrData.getById(resource.workingPeriodDayPrId);
                if (workingPeriodDayPr) {
                    workingPeriodDayPr.addActivity(bookingService);
                } else {
                    console.log("BookingService.addLocallyOnDay - WorkingPeriodDayPr not found given ID - WorkingPeriodDayPr ID: " + resource.workingPeriodDayPrId);
                }
            }
            if (resource.secondariesDayHrsId) {
                for (let k = 0; k < resource.secondariesDayHrsId.length; k++) {
                    let secondaryDayHr = DayHrData.getById(resource.secondariesDayHrsId[k]);
                    if (secondaryDayHr) {
                        secondaryDayHr.addActivity(bookingService, false);
                    } else {
                        console.log("BookingService.addLocallyOnDay - SecondaryDayHr not found given ID - SecondaryDayHr ID: " + resource.secondariesDayHrsId[k]);
                    }
                }
            }
            if (resource.secondariesDayPrsId) {
                for (let k = 0; k < resource.secondariesDayPrsId.length; k++) {
                    let secondaryDayPr = DayPrData.getById(resource.secondariesDayPrsId[k]);
                    if (secondaryDayPr) {
                        secondaryDayPr.addActivity(bookingService, false);
                    } else {
                        console.log("BookingService.addLocallyOnDay - SecondaryDayPr not found given ID - SecondaryDayPr ID: " + resource.secondariesDayPrsId[k]);
                    }
                }
            }
        };

        bsSrv.addLocally = function(id, resource) {
            if (!resource.pkgId) { // subBs managed by pkg
                let bookingService = ActivityData.getById(id);
                if (bookingService && bookingService.version && resource.version && resource.version <= bookingService.version) {
                    return null;
                }

                if (bookingService != null) { //check if resource already exist inside index (current action could be a 'cancel')
                    console.log("BookingService.addLocallyOnDay - Model already exists - BookingService ID: " + id);
                    bookingService.loadObject(resource);
                } else {
                    bookingService = new BookingService(resource);
                    bookingService.id = id;
                }
                bookingService.loadRef();

                bsSrv.addLocallyOnDay(resource,bookingService);
                for (let i = 0; i < resource.subBookingServices.length; i++) {
                    bsSrv.addLocallyOnDay(resource.subBookingServices[i], bookingService.subBookingServices[i]);// subBs on Days
                }
                //add to booking
                if (resource.bookingId && !resource.pkgId) {
                    let booking = BookingData.getById(resource.bookingId);
                    if (booking) {
                        booking.addBookingService(bookingService);
                    } else {
                        console.log("BookingService.addLocallyOnDay - Booking not found given ID in resource - Booking ID: " + resource.bookingId);
                    }
                }
                return bookingService;
            } else {
                return null;
            }
        };

        bsSrv.loadPreviousVersionInstanceOnPage =  function(resource,bookingService)
        {
            if (resource.dayHrId)
                bookingService.dayHr = DayHrData.getById(resource.dayHrId);
            else
            if (resource.workingPeriodDayHrId)
                bookingService.workingPeriodDayHr= WorkingPeriodDayHrData.getById(resource.workingPeriodDayHrId);
            if (resource.dayPrId)
                bookingService.dayPr = DayPrData.getById(resource.dayPrId);
            else
            if (resource.workingPeriodDayPrId)
                bookingService.workingPeriodDayPr= WorkingPeriodDayPrData.getById(resource.workingPeriodDayPrId);

            for (var k=0;k< resource.secondariesDayHrsId.length;k++)
                bookingService.addSecondaryDayHr(DayHrData.getById(resource.secondariesDayHrsId[k]));
            for (var k=0;k< resource.secondariesDayPrsId.length;k++)
                bookingService.addSecondaryDayPr(DayPrData.getById(resource.secondariesDayPrsId[k]));
            if(resource.bookingId)
                bookingService.booking = BookingData.getById(resource.bookingId);
        }
        bsSrv.getPreviousVersionInstance =  function(resource)
        {
            var bookingService =  new BookingService(resource,true);
            bsSrv.loadPreviousVersionInstanceOnPage(resource,bookingService);
            for (var i=0;i< resource.subBookingServices.length;i++)
                bsSrv.loadPreviousVersionInstanceOnPage(resource.subBookingServices[i],bookingService.subBookingServices[i]);// subBs on Days
            return bookingService;

        };

        return bsSrv;
    }
    ]);



// WEBPACK FOOTER //
// ./js/services/models/BookingService.js